import { Wifi } from "lucide-react";

export default function VersionBadge() {
  return (
    <div
      data-testid="version-badge"
      className="fixed bottom-4 left-4 z-[9999] flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#111827]/90 backdrop-blur-sm border border-slate-700/50 shadow-lg"
    >
      <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
      <Wifi className="w-3 h-3 text-emerald-400" />
      <span className="text-[11px] font-mono font-medium text-slate-400">03.2.5-253</span>
    </div>
  );
}
